import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ErrorComponent } from 'src/app/Components/error/error.component';
import { AuthComponent } from './Components/auth/auth.component';
import { AuthGuard } from './Guards/Auth/auth.guard';
import { RoleConst } from 'src/app/Models/roles.const';
import { AccessDeniedComponent } from './Components/access-denied/access-denied.component';
import { HomeComponent } from './Components/home/home.component';
import { AuthErrorComponent } from './Components/auth-error/auth-error.component';
import { SessionExpiredComponent } from './Components/session-expired/session-expired.component';
import { ReservationsComponent } from './Components/reservations/reservations.component';
import { RegisterComponent } from './Components/register/register.component';
import { UpdateProfileComponent } from './Components/update-profile/update-profile.component';
import { UnsupportedBrowserComponent } from './Components/unsupported-browser/unsupported-browser.component';
import { DOCS_DEFAULT_PAGE } from './Services/Documentation/docs.service';
import { MyTeamViewComponent } from './Components/my-team-view/my-team-view.component';
import { SelfRegistrationComponent } from './Components/self-registration/self-registration.component';
import { RegistrationRequestDecisionComponent } from './Components/registration-request-decision/registration-request-decision.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'accessdenied',
    component: AccessDeniedComponent,
  },
  {
    path: 'unsupported-browser',
    component: UnsupportedBrowserComponent,
  },
  {
    path: 'autherror',
    component: AuthErrorComponent,
  },
  {
    path: 'session-expired',
    component: SessionExpiredComponent,
  },
  {
    path: 'docs',
    redirectTo: DOCS_DEFAULT_PAGE,
    pathMatch: 'full',
  },
  {
    path: 'docs',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./Components/docs/docs.component').then((m) => m.DocsComponent),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./Components/docs/docs.component').then((m) => m.DocsComponent),
      },
    ],
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [AuthGuard],
    data: {
      authorizationIdReq: RoleConst.User,
    },
  },
  {
    path: 'self-register',
    component: SelfRegistrationComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'registration-request/:id/:decision',
    component: RegistrationRequestDecisionComponent,
    canActivate: [AuthGuard],
    data: {
      authorizationIdReq: RoleConst.User,
      requireManager: true,
    },
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      authorizationIdReq: RoleConst.User,
    },
  },
  {
    path: 'reservations',
    component: ReservationsComponent,
    canActivate: [AuthGuard],
    data: {
      authorizationIdReq: RoleConst.User,
    },
  },
  {
    path: 'edit-profile',
    component: UpdateProfileComponent,
    canActivate: [AuthGuard],
    data: {
      authorizationIdReq: RoleConst.User,
    },
  },
  {
    path: 'my-team',
    component: MyTeamViewComponent,
    canActivate: [AuthGuard],
    data: {
      authorizationIdReq: RoleConst.User,
      requireManager: true,
      requireActiveMyTeamMembers: true,
    },
  },
  {
    path: 'reports',
    loadChildren: () => import('./features/reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/space-admin/space-admin.module').then((m) => m.SpaceAdminModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/user-admin/user-admin.module').then((m) => m.UserAdminModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/divisions/divisions.module').then((m) => m.DivisionsModule),
  },
  {
    path: 'auth',
    component: AuthComponent,
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
